import { render, staticRenderFns } from "./FoodSalesReport.vue?vue&type=template&id=2f3b40e6&scoped=true"
import script from "./FoodSalesReport.vue?vue&type=script&lang=js"
export * from "./FoodSalesReport.vue?vue&type=script&lang=js"
import style0 from "./FoodSalesReport.vue?vue&type=style&index=0&id=2f3b40e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3b40e6",
  null
  
)

export default component.exports